<template>
	<b-modal
		id="free_cash"
		size="md"
		title-class="font-18"
		@ok="addFreeCash"
		:ok-title="trans.get('__JSON__.Add Free Cash')"
		ok-only
		ok-variant="success"
		lazy
		v-model="showModal"
		@hidden="$emit('hidden')"
		>
		<template #modal-header={close}>
			<div class="d-flex justify-content-between w-100">
				<h4 class="mb-0">{{trans.get('__JSON__.Add Free Cash')}}</h4>
			</div>
			<button type="button" aria-label="Close" class="close" @click="close()">&times;</button>
		</template>
  
		<div class="row">
			<div class="col-12">
				<b-form-group id="input-group-1" :label="trans.get('__JSON__.Free Cash')" label-for="free_cash">
					<b-form-input
					v-model="$v.typeform.free_cash.$model" 
					type="number"
					:placeholder="trans.get('__JSON__.Free Cash')"
					@keypress="onlyNumber($event)"
					:class="{ 'is-invalid': $v.typeform.free_cash.$error }"
					></b-form-input>
					<div v-if="$v.typeform.free_cash.$error" class="invalid-feedback">
						<span v-if="!$v.typeform.free_cash.required">{{
						trans.get("__JSON__.Please enter free cash.")
						}}</span>
					</div>
				</b-form-group>
			</div>
			<div class="col-12">
				<b-form-group id="input-group-1" :label="trans.get('__JSON__.Expiry Days')" label-for="expiry_days">
					<b-form-input
						v-model="$v.typeform.expiry_days.$model" 
						type="number"
						:placeholder="trans.get('__JSON__.Expiry Days')"
						@keypress="onlyNumber($event)"
					></b-form-input>
					<div v-if="$v.typeform.expiry_days.$error" class="invalid-feedback">
						<span v-if="!$v.typeform.expiry_days.numeric">{{
						trans.get("__JSON__.Expiry Days should be numeric.")
						}}</span>
					</div>
				</b-form-group>
			</div>
		</div>
	</b-modal>
</template>

<script>
	import { customerService } from "../../../services";
	import { success_message, error_message } from "../../../Helper/helper";
	import Swal from "sweetalert2";
	import { required, numeric } from "vuelidate/lib/validators";

	export default {
		name: 'addFreeCashModal',
		props: {
			customersIds: Array,
			openModel: Boolean
		},
		components: {
			customerService,
			Swal
		},
		watch: {
			openModel(newVal) {
				this.showModal = newVal;
			},	
		},
		data() {
			return {
				showModal: false,
				typeform: {
					free_cash: '',
					expiry_days: ''
				}
			};
		},
		validations: {
			typeform: {
				free_cash: {
					required
				},
				expiry_days: {
					numeric
				}
			}
		},
		mounted() {
		},
		methods: {
			addFreeCash(bvModalEvt) 
			{
				this.$v.$touch();
				
				if(!this.$v.typeform.$invalid)
				{
					Swal.fire({
						title: "Are you sure?",
						text: "You won't be able to revert this!",
						icon: "success",
						showCancelButton: true,
						confirmButtonColor: "#34c38f",
						cancelButtonColor: "#f46a6a",
						confirmButtonText: "Ok"
					})
					.then(result => {
						if (result.value) 
						{
							this.$emit('loader', true);
							var fd = new FormData();
							fd.append("free_cash", this.typeform.free_cash);
							fd.append("expiry_days", this.typeform.expiry_days);
			
							// Proper way to send array in FormData
							this.customersIds.forEach(id => {
								fd.append("customers_ids[]", id);
							});
			
							customerService.addFreeCash(fd)
							.then(response => {
								
								if (response.data.code === 200) {
									success_message(response.data.message);
									
									this.$emit('hidden');
									// Clear form fields
									this.typeform.free_cash = null;
									this.typeform.expiry_days = null;

									// Optionally clear filters
									this.$emit('clear-filters');
								}
								else
								{
									error_message(response.data.message);
									this.$emit('loader', false);
								}
							})
							.catch(error => {
								console.log(error);
								error_message(error);
								this.$emit('loader', false);
							});
						}
						else
						{
							this.$emit('hidden');
							this.$emit('loader', false);
						}
					})
					.catch(error => {
						console.log(error);
						error_message(error);
						this.$emit('loader', false);
					});
				}
				else
				{
					bvModalEvt.preventDefault();
				}
			},
			onlyNumber(event) {
				const charCode = event.charCode;
				// Allow only numbers (char codes 48-57)
				if (charCode < 48 || charCode > 57) {
					event.preventDefault();
				}
			}
		},
	};
</script>